<template>
  <Modal
    v-model="visiable"
    title="选择管控账号"
    :width="920"
    :mask-closable="false"
    :transfer="false"
    class-name="m-selecter vertical-center-modal"
    @on-ok="ok"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="loading" />
    <selecter
      v-model="mult_account"
      :data="accountData"
      :title="['管控账号']"
      search
      @on-select="selectAll"
      @on-delete="delTag"
      @on-clear="clearTag"
    />
  </Modal>
</template>
<script>
import { isArray, getNameOfData, clearTagOfData, findCheck } from '@/common/js/utils'
import { findAccountByMediaId } from '@/api/tools.model'

import Selecter from '@/components/select/selecter.vue'
export default {
  name: 'ManageAdcount',
  components: { Selecter },
  props: {
    value: {
      type: Boolean
    },
    mediaIds: {
      type: Array,
      default() {
        return [10]
      }
    },
    selector: {
      type: Array
    }
  },
  computed: {
    visiable: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    mult_account() {
      return findCheck(this.accountData)
    }
  },
  methods: {
    bindGetData(val) {
      if (val) {
        this.proload()
      }
    },
    proload() {
      this.loading = true
      findAccountByMediaId({
        mediaIds: this.mediaIds
      }).then((data) => {
        this.loading = false
        if (!data) return
        if (isArray(data) && isArray(this.selector)) {
          this.accountData = data.map((ret) => {
            return {
              id: ret.accountId,
              key: ret.accountId,
              value: ret.accountName,
              check: this.selector.includes(ret.accountId)
            }
          })
        }
      })
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      if (current) {
        const item = getNameOfData(list, current)
        data = item.children
      } else data = list
      data.forEach((ret) => {
        if (ret.children && ret.children.length) {
          ret.children.map((rec) => {
            this.$set(rec, 'check', check)
            return rec
          })
        } else this.$set(ret, 'check', check)
      })
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    },
    ok() {
      const ids = this.mult_account.map((ret) => ret.id)
      this.$emit('on-select', ids)
    }
  },
  data() {
    return {
      loading: null,
      accountData: []
    }
  }
}
</script>
